export function formatPlatform(platform: string | null | undefined): string {
  switch ((platform || '').toLowerCase()) {
    case 'ios':
      return 'iOS';
    case 'macos':
      return 'macOS';
    case 'visionos':
      return 'visionOS';
    case 'tvos':
      return 'tvOS';
    case 'watchos':
      return 'watchOS';
    case 'android':
      return 'Android';
    default:
      return platform || 'Unknown';
  }
}

export function formatSdkPlatform(sdkPlatform: string | null | undefined): string {
  switch ((sdkPlatform || '').toLowerCase()) {
    case 'swift':
      return 'Swift SDK';
    case 'kotlin':
      return 'Kotlin SDK';
    default:
      return sdkPlatform || 'Unknown SDK';
  }
}

/**
 * Qualify a bare OS version with its platform.
 *
 * The Kotlin SDK sends `Build.VERSION.RELEASE` ("14") and the Swift SDK sends a
 * dotted Apple version ("17.4"). Rendered raw and side by side in a mixed
 * portfolio, those are indistinguishable, so a breakdown row of "14" told you
 * nothing about which OS it belonged to.
 */
export function formatOsVersion(
  platform: string | null | undefined,
  osVersion: string | null | undefined
): string {
  const version = (osVersion || '').trim();
  if (!version) return 'Unknown';

  const label = formatPlatform(platform);
  if (label === 'Unknown') return version;

  // Don't double up when the SDK already sent a qualified string.
  if (version.toLowerCase().startsWith(label.toLowerCase())) return version;

  return `${label} ${version}`;
}
